import { render, staticRenderFns } from "./RoutingRules.vue?vue&type=template&id=d610c1be&scoped=true&"
import script from "./RoutingRules.vue?vue&type=script&lang=js&"
export * from "./RoutingRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d610c1be",
  null
  
)

export default component.exports